import HeaderSection from './components/HeaderSection';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <>
      <HeaderSection />
      <main>
        <HeroSection />
        <CardsSection />
        <MediaSection />
        <AppSection />
        <IndexSection />
        <FaqSection />
        <FeaturesSection />
        <AboutSection />
        <RankingSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
        <CarouselSection />
        <TopicsSection />
      </main>
      <FooterSection />
    </>
  );
}